import React, { Component } from 'react';
import { Link, NavLink } from 'react-router-dom';
import logo from '../assets/logo.png';

export class Header extends Component {

  handleBurger() {
    const drawer = document.getElementsByClassName('g-nav-drawer')[0];
    drawer.classList.toggle('show');
  }

  render(){
    return (
      <header className='clearfix'>
        <div className="g-nav-wrapper">
          <div className='g-nav-content clearfix'>
            <div className="g-logo">
              <Link to='/'>
                <img src={logo} alt="緑フラウエンコール" id='midori-logo'/>
              </Link>
            </div>

            <div className="g-nav">
              <ul>
                <li><NavLink to='/history' activeClassName='active'>あゆみ</NavLink></li>
                <li><NavLink to='/director' activeClassName='active'>指導者紹介</NavLink></li>
                <li><NavLink to='/recruit' activeClassName='active'>メンバー募集</NavLink></li>
                <li><NavLink to='/info/1'    activeClassName='active' params={{pageNum: 1}}>Info</NavLink></li>
                <li><NavLink to='/member/schedule'  activeClassName='active'>メンバーページ</NavLink></li>
                <li><NavLink to='/vert-pin-plage'  activeClassName='active'>Vert Pin Plage</NavLink></li>
              </ul>
            </div>

            <div className="hamburger-wrapper">
              <div className='hamburger-icon' onClick={this.handleBurger}>
                <div className="top-bar"></div>
                <div className="middle-bar"></div>
                <div className="bottom-bar"></div>
              </div>
            </div>

          </div>
        </div>

        <div className="g-nav-dummy-space"></div>
      </header>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Header.jsx